import React from "react";



const NavArrow = ({ color, dir }) => <span style={{ color: color || "gray", padding: "0px 10px 0px 10px" }}> {dir === "left" ? "<" : ">"}</span>

export default NavArrow